import { render, staticRenderFns } from "./AthleteDashboard.vue?vue&type=template&id=2a396b2f&"
import script from "./AthleteDashboard.vue?vue&type=script&lang=ts&"
export * from "./AthleteDashboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports